import { render } from "./DeveloperCard.vue?vue&type=template&id=6684b173"
import script from "./DeveloperCard.vue?vue&type=script&lang=js"
export * from "./DeveloperCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__